import React from 'react';
import { styles } from './NavCarousel.css';
import { Carousel, CarouselProps } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type NavCarouselProps = {
  title?: string;
  className?: string;
  titleClassName?: string;
} & CarouselProps;

export const NavCarousel = ({ title, className, titleClassName, children, ...carouselProps }: NavCarouselProps) => {
  return (
    <div className={classNames(styles.container, className)} id="browse-nav">
      {title ? (
        <DomFont className={classNames(styles.title, titleClassName)} as="h3">
          {title}
        </DomFont>
      ) : null}
      <Carousel
        showProgressBar={false}
        showPagination={false}
        slidesPerView="auto"
        gradientColor={palette.secondary.main}
        spaceBetween={10}
        slidesPerGroup={2}
        slidesOffsetBefore={3}
        slidesOffsetAfter={3}
        freeMode={{ enabled: true, momentumVelocityRatio: 0.75, momentumRatio: 0.75 }}
        {...carouselProps}
      >
        {children}
      </Carousel>
    </div>
  );
};
